var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoInBeeSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.986,
    height: 45.267,
    viewBox: "0 0 45.986 45.267",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_22175",
    "data-name": "Raggruppa 22175",
    transform: "translate(16424.525 -12636.219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33106",
    "data-name": "Tracciato 33106",
    d: "M177.212,1790.879a11,11,0,1,0,10.8-16.536l-9.618-.06v-.987l9.68.061a11.989,11.989,0,1,1-11.386,18.549q.284-.5.524-1.027",
    transform: "translate(-16577.199 10883.589)",
    fill: "#191a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33107",
    "data-name": "Tracciato 33107",
    d: "M155.763,1753.163h-.986v-5.221l-.058.05.051-2.225,0-.109c0-.047,0-.094,0-.141a11,11,0,1,0-17.16,9.116q-.48.249-.937.535a11.985,11.985,0,1,1,19.083-9.652c0,.091,0,.181-.007.272l.007-.006Z",
    transform: "translate(-16555.629 10902.691)",
    fill: "#191a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33108",
    "data-name": "Tracciato 33108",
    d: "M143.319,1772.231h-.186c-.114,0-.229,0-.343,0l-.559.026-.229.015a12.6,12.6,0,0,0-11.489,11.508l-.01.573-.031,13.032h12.578l.261,0,.038,0,.749-.043a12.6,12.6,0,0,0,11.49-11.53l.012-1,.028-12.578Zm-.268,24.05c-.049,0-.1,0-.148,0l-1.444-.023-9.841-9.841-.035-1.449c0-.052,0-.1,0-.155a11.4,11.4,0,0,1,1.616-5.862l15.718,15.718a11.4,11.4,0,0,1-5.862,1.616m11.468-11.629c0,.052,0,.1,0,.157a11.4,11.4,0,0,1-1.241,5.181l-15.411-15.411a11.4,11.4,0,0,1,5.181-1.241c.054,0,.107,0,.16,0l1.005,0h1.455l8.851,8.851v1.285Z",
    transform: "translate(-16555 10884.1)",
    fill: "#f6aa4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33109",
    "data-name": "Tracciato 33109",
    d: "M191.682,1756.609a6.861,6.861,0,1,0-9.713-.01,6.868,6.868,0,0,0,9.713.01",
    transform: "translate(-16578.775 10897.239)",
    fill: "#f6aa4e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInBeeSmall);
export default __webpack_public_path__ + "static/media/logoInBeeSmall.de41b12a9cecd7650d1ffad717af6303.svg";
export { ForwardRef as ReactComponent };